import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './modules/auth'
import { agent } from './modules/agent'
import { call } from './modules/call'
import { general } from './modules/general'
import { conversation } from './modules/conversation'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    agent,
    call,
    general,
    conversation
  },
  plugins: [createPersistedState()]
})
